async function signup(formData) {
  try {
    const response = await fetch("/wp-json/wf/v1/signup-newsletter", {
      method: "POST",
      body: formData,
    });
    const result = await response.json();
    return result;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("API-Error:", error);
    return error;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  [...document.querySelectorAll("[data-newsletter-signup-form]")].forEach(
    (form) => {
      const errorEl = document.createElement("p");
      form.addEventListener("submit", async (e) => {
        e.preventDefault();

        const formdata = new FormData(e.target);
        signup(formdata).then((res) => {
          if (res.status === "success") {
            const successString = form.dataset.newsletterSuccess;
            const successEl = document.createElement("h3");
            successEl.innerHTML = successString;
            form.parentNode.appendChild(successEl);
            form.remove();
            errorEl.remove();
          } else {
            const errorString = form.dataset.newsletterError;
            errorEl.classList.add("px-gutter", "mx-gutter-1/2");
            errorEl.innerHTML = errorString;
            form.parentNode.appendChild(errorEl);
          }
        });
      });
    }
  );
});
